<template>
  <div>
    <PermissionDenied />
  </div>
</template>

<script setup>
import PermissionDenied from "@/components/elements/PermissionDenied.vue";
</script>

<style lang="scss" scoped></style>
